import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

interface TenantInfo {
  id: string;
  name: string;
  identifier: string;
  logoUrl?: string;
  primaryColor?: string;
  features: string[];
}

interface TenantState {
  // State
  tenantId: string | null;
  tenantInfo: TenantInfo | null;

  // Actions
  setTenant: (info: TenantInfo) => void;
  clearTenant: () => void;

  // Feature flags
  hasFeature: (feature: string) => boolean;
}

export const useTenantStore = create<TenantState>()(
  persist(
    (set, get) => ({
      // Initial state
      tenantId: null,
      tenantInfo: null,

      // Actions
      setTenant: (info) =>
        set({
          tenantId: info.id,
          tenantInfo: info,
        }),

      clearTenant: () =>
        set({
          tenantId: null,
          tenantInfo: null,
        }),

      // Feature flag helper
      hasFeature: (feature) => {
        const { tenantInfo } = get();
        if (!tenantInfo) return false;
        return tenantInfo.features.includes(feature);
      },
    }),
    {
      name: 'tcy-tenant-storage',
      storage: createJSONStorage(() => localStorage),
    }
  )
);

// Feature flags
export const FEATURES = {
  AI_DIAGNOSIS: 'ai_diagnosis',
  AI_QUICK_INTAKE: 'ai_quick_intake',
  MAIL_IN_REPAIR: 'mail_in_repair',
  MULTI_BRANCH: 'multi_branch',
  WHATSAPP: 'whatsapp',
  SMS: 'sms',
  ICOUNT: 'icount',
  YESINVOICE: 'yesinvoice',
  PAYMENTS: 'payments',
} as const;
